export enum SpanDirection {
    ROOM_LENGTH = "ROOM_LENGTH",
	ROOM_WIDTH = "ROOM_WIDTH"
}